import { css } from 'styled-components';

const baseIconStyles = ({ color, fill }) => {
    var _a;
    const resolvedColor = (_a = fill !== null && fill !== void 0 ? fill : color) !== null && _a !== void 0 ? _a : 'currentColor';
    return css `
    vertical-align: baseline;
    &.fi-icon {
      display: inline-block;
    }
    .fi-icon-base-fill {
      fill: ${resolvedColor};
    }
    .fi-icon-base-stroke {
      stroke: ${resolvedColor};
    }
    &.fi-icon--cursor-pointer {
      cursor: pointer;
      & * {
        cursor: inherit;
      }
    }
  `;
};
const staticIconStyles = ({ highlightColor, baseColor }) => css `
  vertical-align: baseline;
  &.fi-static-icon {
    display: inline-block;
  }
  &.fi-icon--cursor-pointer {
    cursor: pointer;
    & * {
      cursor: inherit;
    }
  }
  ${!!highlightColor &&
    `.fi-icon-illustrative-highlight-fill {
    fill: ${highlightColor};
  }
  .fi-icon-illustrative-highlight-stroke {
    stroke: ${highlightColor}
  }
  `}
  ${!!baseColor &&
    `.fi-icon-illustrative-base-fill {
    fill: ${baseColor};
  }
  .fi-icon-illustrative-base-stroke {
    stroke: ${baseColor}
  }
  `}
`;
const logoIconStyles = () => css `
  display: inline-block;
  vertical-align: baseline;
  &.fi-icon--cursor-pointer {
    cursor: pointer;
    & * {
      cursor: inherit;
    }
  }
`;

export { baseIconStyles, logoIconStyles, staticIconStyles };
//# sourceMappingURL=styles.js.map
